import React, { useState, useEffect } from "react";
import TabcordionMediaCard from "components/page/campaign/tabcordion/TabcordionMediaCard";
import TabcordionLinks from "components/page/campaign/tabcordion/TabcordionLinks";
import { sanitizeHtml } from "utils/sanitizeHtml";

let tabsToggle = [];
const TabcordionTabsMobile = (props) => {
	const { componentTitle, tabs, onClick } = props;
	useEffect(() => {
		createArray(tabs, tabsToggle);
	}, [tabs]);
	const [toggleTrueFalse, setToggleTrueFalse] = useState(tabsToggle);

	const createArray = (tabs, tabsToggle) => {
		for (let i = 0; i < tabs.length; i++) {
			tabsToggle[i] = false;
		}
	};

	const onMobileTabClick = (tabID) => {
		toggleMobileTab(tabID);
		onClick(tabID);
	};

	const toggleMobileTab = (tabID) => {
		for (let i = 0; i < tabs.length; i++) {
			if (i === tabID) {
				tabsToggle[tabID] = !tabsToggle[tabID];
			} else {
				tabsToggle[i] = false;
			}
		}
		setToggleTrueFalse([...tabsToggle]);
	};
	return (
		<div className="tabcordion-mobile-ribbon md-hidden xxl-hidden">
			{tabs.map((tab, i) => (
				<div key={i} className="tabcordion-mobile-dropdown">
					<div
						className={
							toggleTrueFalse[tab.id] === true
								? "tabcordion-mobile-dropdown-title toggle"
								: "tabcordion-mobile-dropdown-title"
						}
						role="button"
						aria-label={tab.label}
						data-a="true"
						data-a-evt="Subcontent View"
						data-a-comp={componentTitle + " Tabcordion"}
						data-a-text={tab.label}
						tabIndex="0"
						onClick={() => onMobileTabClick(tab.id)}
						onKeyUp={() => {}}
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.label) }}
					></div>

					<div
						className={
							toggleTrueFalse[tab.id] === true
								? "tabcordion-mobile-dropdown-content show"
								: "tabcordion-mobile-dropdown-content hide"
						}
					>
						<div key={tab.id} className="tabcordion--content ">
							<div
								className="tabcordion--content-description t-body-md-heavy"
								dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.goalHeadline) }}
							></div>
							{tab.type === "One-Column-Image" ? (
								<div className="tabcordion-mobile-image">
									<img aria-label={tab.alt} src={tab.image} alt={tab.alt} />
								</div>
							) : (
								<div>
									<div
										className="tabcordion--two-column-description t-body-md"
										dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.goalDescription) }}
									/>
									<TabcordionMediaCard tab={tab} />
									<TabcordionLinks componentTitle={componentTitle} tab={tab} />
								</div>
							)}
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default TabcordionTabsMobile;
